import { SquareModelColorStatus } from "../../../enums/SquareModelColorStatus";
import { SquareModelFigureStatus } from "../../../enums/SquareModelFigureStatus";
import { ITriangleModel } from "../../triangle/ITriangleModel";
import { ISquareModel } from "../ISquareModel";

export class SquareModel implements ISquareModel {
    private readonly triangles: Array<ITriangleModel>;
    private colorStatus: SquareModelColorStatus;
    private figureStatus: SquareModelFigureStatus;

    public constructor(startTriangles: Array<ITriangleModel>) {
        this.triangles = Array.from(startTriangles);
        this.updateStatus();
    }

    public updateStatus(): void {
        // Update figure status
        if (this.triangles.length == 0) {
            this.figureStatus = SquareModelFigureStatus.EMPTY;
        } else {
            this.figureStatus = this.triangles.length == 1 ? SquareModelFigureStatus.HALF : SquareModelFigureStatus.FULL;
        }
        // Update color status
        if (this.triangles.length != 2) {
            this.colorStatus = SquareModelColorStatus.NOT_FULL;
            return;
        }
        for (const triangle of this.triangles) {// WTF????
            if (triangle == null) {
                this.colorStatus = SquareModelColorStatus.NOT_FULL;
                return;
            }
        }
        if (this.triangles[0].Color == this.triangles[1].Color) {
            this.colorStatus = SquareModelColorStatus.SAME;
        } else {
            this.colorStatus = SquareModelColorStatus.DIFFERENT;
        }
    }

    public get ColorStatus(): SquareModelColorStatus {
        return this.colorStatus;
    }

    public get FigureStatus(): SquareModelFigureStatus {
        return this.figureStatus;
    }

    public get Triangles(): Array<ITriangleModel> {
        return this.triangles;
    }
}